import { getAuthCase } from './auth-case'
import { getUrlParam } from './url-param'
import { ApplicationParam } from '../interfaces'

const paramNames: ApplicationParam[] = [
  'section',
  'navsid',
  'session_dc',
  'portal'
]

export function getAppUrl(): URL {
  const url = new URL(`${location.origin}${location.pathname}`)

  const authCase = getAuthCase()
  /* istanbul ignore next else */
  if (authCase) {
    url.searchParams.set('case', authCase)
  }

  paramNames.forEach((name: ApplicationParam) => {
    const value = getUrlParam(name)
    /* istanbul ignore next else */
    if (value) {
      url.searchParams.set(name, value)
    }
  })

  return url
}
